import React, { useState } from "react";
import { Helmet } from 'react-helmet';
import Logo from "../images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { RiArrowGoBackLine } from "react-icons/ri";
import { buildApiUrl } from "../utils/api";

function Admin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false); // Loading state
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const loginData = {
            username: email,
            password: password,
        };
        console.log("data:",loginData);

        setLoading(true); // Start loading

        try {
            const response = await fetch(buildApiUrl('/api/auth/login'), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(loginData),
            });

            const data = await response.json();

            if (response.ok) {
                localStorage.setItem("token", data.token);
                console.log("Login successful:", data);
                navigate("/adminDashboard");
            } else {
                alert(data.message);
            }
        } catch (error) {
            console.error("Error during login:", error);
        } finally {
            setLoading(false); // Stop loading
        }
    };

    return (
        <>
            <Helmet>
                <title>Admin Login | 3pl Site</title>
            </Helmet>
            <div className="adminBody">
                <img src={Logo} alt="" />
                <div className="container admin" style={{ paddingTop: "10px", color: "#E0A75E", fontSize: "xxx-large" }}>
                    <h1>ADMIN LOGIN PAGE</h1>
                </div>
                <div className="container login d-flex justify-content-center" style={{ marginTop: "50px" }}>
                    <div className="row text-start">
                        <form onSubmit={handleSubmit} className="login-from" style={{ padding: "2rem 6rem" }}>
                            <div className="mb-3">
                                <label htmlFor="exampleInputEmail1" className="form-label">Username</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="exampleInputEmail1"
                                    placeholder="Your E-mail"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleInputPassword1" className="form-label">Password</label>
                                <div className="input-group">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        className="form-control"
                                        id="exampleInputPassword1"
                                        placeholder="Enter Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div>
                                <div className="d-flex align-items-center mt-2">
                                    <input
                                        type="checkbox"
                                        id="showPassword"
                                        onClick={() => setShowPassword(!showPassword)}
                                    />
                                    <label htmlFor="showPassword" className="ms-2">
                                        {showPassword ? "Hide Password" : "Show Password"}
                                    </label>
                                </div>
                            </div>
                            <button type="submit" className="btn" disabled={loading}>
                                {loading ? "Logging in..." : "Submit"}
                            </button>
                            <div className="d-flex justify-content-center mt-3">
                                <p><Link to="/" style={{textDecoration:"none", color:"#fff"}}><RiArrowGoBackLine/> Go Back to Home Page</Link></p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Admin;
